import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { authReducer } from './auth.reducer';
import { AuthEffects } from './auth.effects';

/**
 * Auth State Module
 * 
 * Feature module that encapsulates all auth-related state management.
 * This module can be imported wherever auth state is needed.
 */
@NgModule({
  imports: [
    StoreModule.forFeature('auth', authReducer),
    EffectsModule.forFeature([AuthEffects])
  ]
})
export class AuthStateModule {}
